import Table from "@/components/Table/table";
import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifButton,
  MotifCheckbox,
  MotifProgressLoader,
  MotifToast,
} from "@ey-xd/motif-react";
import React, { useMemo, useState } from "react";
import "./UnitConversionManagement.scss";
import { useNavigate, useParams } from "react-router-dom";
import {
  useDeleteUnitMutation,
  useGetUnitsListDataQuery,
} from "@/services/unit/unitReducers";
import ConfirmationModalUnit from "./ConfimationModalUnit";
import ConfimationModalOK from "./ConfimationModalOK";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import CustomPagination from "@/components/Pagination/CustomPagination";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { havingAddPermission, havingDeletePermission } from "@/utility/common";
import {
  CREATE_BUTTON_VARIANT,
  GetCommonDeleteImgButton,
} from "@/components/Images/CommonImages";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";

interface Unit {
  default: string;
  name: string;
  unitName: string;
  description: string;
  rate: string;
  decimalPlace: string;
  setFetch?: any;
  isDefaultCurrency?: boolean;
  id?: string;
}
interface CheckBoxCellRenderProps {
  data: {
    name: string;
    isDefaultCurrency: boolean;
    isChecked: boolean;
  };
}
export default function UnitConversionManagement() {
  const { caseId } = useParams<{ caseId: string }>();
  const [isVisible, setIsVisible] = useState(false);
  const [isOKVisible, setIsOKVisible] = useState(false);
  const { t } = useTranslation();
  const [selectedCheckbox, setSelectedCheckbox] = useState<string | null>(null);
  const navigate = useNavigate();
  const [deleteUnit, { isLoading: delteUnitLoading }] = useDeleteUnitMutation();
  const [unitToDelete, setUnitToDelete] = useState<Unit | null>(null);
  const [okConfirmationMessage, setOkConfirmationMessage] = useState(
    "Default Currency cannot be deleted"
  );
  const permissions = useSelector((state: any) => state.permissions);
  const [toastMessage, setToastMessage] = useState<any>({
    message: "",
    variant: "",
    show: false,
  });

  const { Unit } = permissions;
  const paginationPageSize: number = customPaginationPageSize;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  let tableLoadingData = customTableLoadingData;
  const retainState = useSelector(
    (e: any) => e.retainState.currencyListTabState
  );
  const dispatch = useDispatch();
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      caseId: caseId,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize || paginationPageSize,
      SearchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  }, [caseId, paginationPageSize, retainState]);
  const paginationObj = getPaginationObj
  const { data, isLoading, isFetching, error, refetch,status } =
    useGetUnitsListDataQuery(paginationObj);

  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "currencyListTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }

  const headerData = {
    title: "pages.configuration.units.tableTitle",
    description: "pages.configuration.units.tableDescription",
  };
  const [accordionOpen, setAccordionOpen] = useState(true);

  const CheckBoxCellRender = (props: CheckBoxCellRenderProps) => {
    const { name, isDefaultCurrency } = props.data;
    const isChecked =
      selectedCheckbox === name ||
      (isDefaultCurrency && selectedCheckbox === null);
    return (
      <>
        <div className="checkbox-dark mar-t-10">
          <MotifCheckbox
            id={`checkbox-${name}`}
            name={`checkbox-${name}`}
            checked={isChecked}
            onChange={() => handleCheckboxChange(name, isChecked)}
            hideLabels={true}
            disabled={true}
          >
            <></>
          </MotifCheckbox>
        </div>
      </>
    );
  };

  if (isLoading) {
    return <MotifProgressLoader show variant="default" />;
  }

  const handleDeleteClick = (unitData: Unit) => {
    setToastMessage({ message: "", variant: "", show: false });
    if (unitData.isDefaultCurrency) {
      setIsOKVisible(true);
      setUnitToDelete(unitData);
      return;
    }
    setUnitToDelete(unitData);
    setIsVisible(true);
  };

  const ActionsCellRenderer = (props: any) => {
    const unitData = props.data;
    return (
      <>
        {
          havingDeletePermission(Unit) && (
            <GetCommonDeleteImgButton
              onClick={() => {
                handleDeleteClick(unitData);
              }}
            ></GetCommonDeleteImgButton>
          )
          //         <div>
          //           <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
          //           <MotifButton
          //             size="small"
          //             variant={DELETE_IMG_VARIANT}
          //             onClick={() => {
          //               handleDeleteClick(unitData);
          //             }}
          //           >
          // {getCommonDeleteImg()}          </MotifButton>
          //           </CommonTooltipWrapper>
          //         </div>
        }
        {/* <MotifButton
          size="small"
          variant="primary"
          onClick={() => handleEditClick(unitData)}
        >
          <MotifIcon
            title="Edit Unit"
            fill="none"
            iconFunction={contentIcCreate24px}
          />
        </MotifButton> */}
      </>
    );
  };
  const handleCellClick = (params: any) => {
    const data = params.data;
    navigate(`/case/${caseId}/configuration/unit-setup`, { state: { data } });
  };

  const columnDefs = (handleCellClick: (params: any) => void) => [
    {
      cellRenderer: CheckBoxCellRender,
      comparator: () => 0,
      field: "isDefaultCurrency",
      headerName: t("pages.configuration.units.tableColumnDetails.column1"),
      flex: 1,
      sortable: false,
      unSortIcon: true,
      minWidth: 50,
    },
    {
      cellRenderer: "unitNameCellRenderers",
      comparator: () => 0,
      field: "name",
      type: "unitNameType",
      headerName: t("pages.configuration.units.tableColumnDetails.column2"),
      flex: 1,
      sortable: true,
      unSortIcon: true,
      onCellClicked: handleCellClick,
      cellStyle: { cursor: "pointer" },
      cellClass: "text-bold-underline",
      minWidth: 150,

    },
    {
      comparator: () => 0,
      field: "description",
      type: "descriptionType",
      headerName: t("pages.configuration.units.tableColumnDetails.column3"),
      flex: 1,
      sortable: true,
      unSortIcon: true,
      wrapText: true,
      autoHeight: true,
      cellClass: "overFlowWrapAnywhere",
      minWidth: 150,

    },
    {
      cellRenderer: "rateCellRenderers",
      comparator: () => 0,
      field: "exchangeRate",
      type: "rateType",
      headerName: t("pages.configuration.units.tableColumnDetails.column4"),
      flex: 1,
      sortable: true,
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
      unSortIcon: true,
      minWidth: 150,

    },
    {
      cellRenderer: "decimalPlaceCellRenderers",
      comparator: () => 0,
      field: "decimalPlace",
      type: "decimalPlaceType",
      headerName: t("pages.configuration.units.tableColumnDetails.column5"),
      flex: 1,
      sortable: true,
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
      unSortIcon: true,
      minWidth: 150,

    },
    {
      cellRenderer: ActionsCellRenderer,
      field: "action",
      headerName: "",
      flex: 1,
      sortable: false,
      cellClass: "align-right",
      minWidth: 60,

    },
  ];

  const handleCreateNew = () => {
    navigate(`/case/${caseId}/configuration/unit-setup`);
  };

  const handleCheckboxChange = (name: string, isChecked: boolean) => {
    setSelectedCheckbox(selectedCheckbox === name ? null : name);
  };

  const cancelBtnHandler = () => {
    setIsVisible(false);
  };

  const confirmBtnHandler = async () => {
    if (unitToDelete) {
      try {
        await deleteUnit(unitToDelete.id).unwrap();
        setIsVisible(false);
        refetch();
        setToastMessage({
          message: t("pages.configuration.units.successfullyDeleted"),
          variant: "success",
          show: true,
        });
      } catch (error) {
        setIsVisible(false);
        setIsOKVisible(true);
        const errorMessage =
          (error as { data?: { message?: string } }).data?.message ||
          "Unit cannot be deleted";
        setOkConfirmationMessage(errorMessage);
        if ((error as { status?: number })?.status === 400) {
          console.error("Error 400: Bad Request", errorMessage);
        } else {
          console.error("Failed to delete the unit", errorMessage);
        }
      }
    }
  };

  const confirmationMessage =
    "pages.configuration.units.deleteConfirmationMessage";

  const handleOkButton = () => {
    setIsOKVisible(false);
  };

  return (
    <>
      {toastMessage.show && (
        <MotifToast
          onClose={() => {
            setToastMessage({ message: "", variant: "", show: false });
          }}
          variant={toastMessage.variant}
        >
          {toastMessage.message}
        </MotifToast>
      )}
      <MotifAccordion
        alignIconRight={true}
        useChevronIcon={true}
        className="accordion"
        onClose={() => {
          setAccordionOpen(false);
        }}
        onOpen={() => {
          setAccordionOpen(true);
        }}
        open={accordionOpen}
      >
        <MotifAccordionTrigger className="accordion-trigger-button">
          {t("pages.configuration.units.mainTitle")}
        </MotifAccordionTrigger>
        <MotifAccordionContent>
          <Table
            columnDefs={columnDefs(handleCellClick)}
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            cellRenderers={isFetching ? [] : data?.results ? data?.results : []}
            TitleComplement={() =>
              havingAddPermission(Unit) ? (
                <MotifButton
                  variant={CREATE_BUTTON_VARIANT}
                  onClick={handleCreateNew}
                >
                  {t("pages.configuration.units.newUnit")}
                </MotifButton>
              ) : (
                <></>
              )
            }
            title={headerData.title}
            description={headerData.description}
            pagination={false}
            overlayNoRowsTemplate={
              isFetching
                ? t(tableLoadingData)
                : error
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          <CustomPagination
           apiData={data}
           apiStatus={status}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!data?.hasMoreRecords}
            onChangePageSize={(page: number) => {
              dispatch(
                setComponentState1({
                  entityName: "currencyListTabState",
                  entityState: {
                    PageSize: page,
                    PageNumber: 1,
                  },
                })
              );
            }}
            onChangeNextPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "currencyListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber + 1,
                  },
                })
              );
            }}
            onChangePreviousPage={() => {
              dispatch(
                setComponentState1({
                  entityName: "currencyListTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber - 1,
                  },
                })
              );
            }}
            pageSizeSelector={paginationPageSizeSelector}
          />
        </MotifAccordionContent>
      </MotifAccordion>

      <ConfimationModalOK
        isVisible={isOKVisible}
        setIsVisible={setIsOKVisible}
        handleOkButton={handleOkButton}
        confirmationMessage={okConfirmationMessage}
        unitToDelete={unitToDelete?.name}
      />
      <ConfirmationModalUnit
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        cancelBtnHandler={cancelBtnHandler}
        confirmBtnHandler={confirmBtnHandler}
        confirmationMessage={confirmationMessage}
        loadingFlag={delteUnitLoading}
        unitToDelete={unitToDelete?.name}
      />
    </>
  );
}
